import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Базовый класс опций для конролов. */
let DxBaseControlOptions = class DxBaseControlOptions {
    /** Базовый класс опций для конролов. */
    constructor() {
        /** Доступность контрола по умолчанию. */
        this._isDisabled = false;
        /** Видимость контрола по умолчанию контрола по умолчанию. */
        this._isHidden = false;
    }
    get controlId() {
        return this._controlId;
    }
    set controlId(value) {
        this._controlId = value;
    }
    get label() {
        return this._label;
    }
    set label(value) {
        this._label = value;
    }
    get hint() {
        return this._hint;
    }
    set hint(value) {
        this._hint = value;
    }
    get isDisabled() {
        return this._isDisabled;
    }
    set isDisabled(value) {
        this._isDisabled = value;
    }
    get isHidden() {
        return this._isHidden;
    }
    set isHidden(value) {
        this._isHidden = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "controlId", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxBaseControlOptions.prototype, "_controlId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "label", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxBaseControlOptions.prototype, "_label", void 0);
tslib_1.__decorate([
    jsonMember({ name: "hint", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxBaseControlOptions.prototype, "_hint", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isDisabled", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxBaseControlOptions.prototype, "_isDisabled", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isHidden", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxBaseControlOptions.prototype, "_isHidden", void 0);
DxBaseControlOptions = tslib_1.__decorate([
    jsonObject
], DxBaseControlOptions);
export { DxBaseControlOptions };
